// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-title-org{
  color: #323232;
  font-size: 30px;
  text-align:center;
}
.label-head{
color:black;
  font-weight: 500;
  font-size: 12px;
  margin:10px auto 5px 5px;
}

.input-box{
  width: 248px;
  height: 40px;
  border: 1px solid #797979;
  border-radius: 4px;
  padding-left: 10px;
  outline:none;
}

.input-box-disabled::placeholder{
  background: transparent !important;
  color: #C9C9C9;
  font-size: 14px;
}
.input-box-disabled{
  background: transparent !important;
}

.select-box{
  width: 248px;
padding-left: 8px;
-webkit-appearance: none;
background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
background-size: 12px 7px !important;
background-repeat: no-repeat;
background-size: 4%;
background-position: top 50% right 4%;
outline:none;
}

.checkbox-label{
  font-size: 14px;
  font-weight: 400;
  margin-left: 0;
  margin-top: 10px;
}

.text-button{
font-weight: 500;
font-size: 16px;
color: #68AD3F;
text-align: center;
cursor:pointer;
}

.auth-error{
  color:red;
  font-size: 12px;
}

::placeholder {
  /* Internet Explorer 10-11 */
  font-size: 14px;
  color: #EAEAEA;
  margin-left: 10px;
}

.org-account-outer{
  display: flex;
  justify-content:center;
  margin-top:50px;
}
.org-account-inner{
  width:500px;
}
.account-content{
font-weight: 400;
font-size: 16px;
}
.recover-pwd-msg{
  font-size: 15px;
  color: #323232;
}
.recover-alert{
  min-width:320px !important;
}
@media only screen and (min-width: 0px) and (max-width: 480px) {
  .org-account-inner{
    width:250px;
  }
  .account-content{
    font-size: 12px;
    }
    .recover-pwd-msg{
      font-size: 12px;
    }
    .auth-title-org-mob{
      font-size:24px;
    }
    .org-account-outer{
      padding: 0 5%;
      justify-content: flex-start;
      margin-top: 20px;
    }
    .org-account-inner{
      width:100%;
    }
    .recover-alert{
      min-width:260px !important;
    }
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
  .org-account-inner{
    width:400px;
  }
  .account-content{
    font-size: 14px;
    }
    .org-account-outer{
      padding: 0 5%;
      justify-content: flex-start;
      margin-top: 20px;
    }
    .org-account-inner{
      width:100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Organizer/Auth/Auth.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;AACA,WAAW;EACT,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd,iBAAiB;AACjB,wBAAwB;AACxB,yDAAqD;AACrD,oCAAoC;AACpC,4BAA4B;AAC5B,mBAAmB;AACnB,qCAAqC;AACrC,YAAY;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;AACA,gBAAgB;AAChB,eAAe;AACf,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAeA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;AACA,gBAAgB;AAChB,eAAe;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,cAAc;IAChB;IACA;MACE,aAAa;MACb,2BAA2B;MAC3B,gBAAgB;IAClB;IACA;MACE,UAAU;IACZ;IACA;MACE,0BAA0B;IAC5B;AACJ;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf;IACA;MACE,aAAa;MACb,2BAA2B;MAC3B,gBAAgB;IAClB;IACA;MACE,UAAU;IACZ;AACJ","sourcesContent":[".auth-title-org{\n  color: #323232;\n  font-size: 30px;\n  text-align:center;\n}\n.label-head{\ncolor:black;\n  font-weight: 500;\n  font-size: 12px;\n  margin:10px auto 5px 5px;\n}\n\n.input-box{\n  width: 248px;\n  height: 40px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  padding-left: 10px;\n  outline:none;\n}\n\n.input-box-disabled::placeholder{\n  background: transparent !important;\n  color: #C9C9C9;\n  font-size: 14px;\n}\n.input-box-disabled{\n  background: transparent !important;\n}\n\n.select-box{\n  width: 248px;\npadding-left: 8px;\n-webkit-appearance: none;\nbackground-image: url(\"../../Assets/selectArrow.png\");\nbackground-size: 12px 7px !important;\nbackground-repeat: no-repeat;\nbackground-size: 4%;\nbackground-position: top 50% right 4%;\noutline:none;\n}\n\n.checkbox-label{\n  font-size: 14px;\n  font-weight: 400;\n  margin-left: 0;\n  margin-top: 10px;\n}\n\n.text-button{\nfont-weight: 500;\nfont-size: 16px;\ncolor: #68AD3F;\ntext-align: center;\ncursor:pointer;\n}\n\n.auth-error{\n  color:red;\n  font-size: 12px;\n}\n\n::-webkit-input-placeholder {\n   /* Edge */\n  font-size: 14px;\n  color: #EAEAEA;    \n}\n\n:-ms-input-placeholder { \n  /* Internet Explorer 10-11 */\n  font-size: 14px;\n  color: #EAEAEA;\n  margin-left: 10px;\n}\n\n::placeholder {\n  /* Internet Explorer 10-11 */\n  font-size: 14px;\n  color: #EAEAEA;\n  margin-left: 10px;\n}\n\n.org-account-outer{\n  display: flex;\n  justify-content:center;\n  margin-top:50px;\n}\n.org-account-inner{\n  width:500px;\n}\n.account-content{\nfont-weight: 400;\nfont-size: 16px;\n}\n.recover-pwd-msg{\n  font-size: 15px;\n  color: #323232;\n}\n.recover-alert{\n  min-width:320px !important;\n}\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n  .org-account-inner{\n    width:250px;\n  }\n  .account-content{\n    font-size: 12px;\n    }\n    .recover-pwd-msg{\n      font-size: 12px;\n    }\n    .auth-title-org-mob{\n      font-size:24px;\n    }\n    .org-account-outer{\n      padding: 0 5%;\n      justify-content: flex-start;\n      margin-top: 20px;\n    }\n    .org-account-inner{\n      width:100%;\n    }\n    .recover-alert{\n      min-width:260px !important;\n    }\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .org-account-inner{\n    width:400px;\n  }\n  .account-content{\n    font-size: 14px;\n    }\n    .org-account-outer{\n      padding: 0 5%;\n      justify-content: flex-start;\n      margin-top: 20px;\n    }\n    .org-account-inner{\n      width:100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
